import {take, range, partial} from 'lodash'
import Fade from '@mui/material/Fade'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import context, {Consumer} from '../../../context'
import confirmDialog from '../../confirm-dialog'
import TopBar from './topbar'
import {isEmpty} from '../../../helpers/utils'
import GeneralInfo from './general-info'
import GroupDateInfo from './group-date-info'
import AddLesson from './add-lesson'
import AddStandard from './add-standard'
import AddResource from './add-resource'
import Field from './field'
import update from 'immutability-helper'
import './plan.styl'
import { Loader } from '../../loader'

function validatePlan (plan) {
  const missing = ['title', 'grade', 'subject', 'clique'].filter(field => isEmpty(plan[field]))
  return {canSave: missing.length == 0, missing}
}

export default function PlanView (props) {

  const {date} = props

  return (<Consumer>{ context => {
    const {newPlan, languageId, link, loading} = context
    const {items = []} = newPlan
    const validation = validatePlan(newPlan)

    const moveField = (drag, hover) => {
      const field = newPlan.items[drag]
      const items = update(newPlan.items, {$splice: [[drag, 1], [hover, 0, field]]})
      context.setState({newPlan: {...newPlan, items}})
    }

    const deleteField = (index, title) => {
      return () => {
        confirmDialog({
          className: 'delete-field',
          translate: context.translate,
          children: (
            <div className="message">
              <div className="question">
                {context.translate('confirm_delete_item')}
              </div>
              <div className="title">
                {title}
              </div>
            </div>
          ),
          onConfirm: () => {
            const items = update(newPlan.items, {$splice: [[index,1]]})
            context.setState({newPlan: {...newPlan, items}})
          }
        })
      }
    }

    const fields = items.map((field, index) => {
      return (
        <Field
          key={field.id}
          index={index}
          id={field.id}
          className={field.name}
          moveField={moveField}
          deleteField={deleteField(index, field.content.name)}
          context={context}
          {...field.content}
        />
      )
    })

    return (
      <div className="planning new view">
        <Loader isLoading={loading.isLoading} />
        <div className="wrapper">
          <TopBar plan={newPlan} validation={validation} updatePlan={(plan, afterUpdate) => { context.setState({newPlan: plan}, afterUpdate) }} />
          {newPlan.id && (
            // <Fade in={context.planUpdated}>
              <div id="new-plan" className="content-wrapper">
                <div className="content">
                  <div id="fields" className="fields">
                    <GeneralInfo title={newPlan.title} unit={newPlan.unit} validation={validation} />
                    {fields}
                  </div>
                  <div className="side-panel">
                    <GroupDateInfo validation={validation} />
                    <AddStandard />
                    <AddLesson />
                    <AddResource />
                  </div>
                </div>
              </div>
            // </Fade>
          )}
        </div>
      </div>
    )}}</Consumer>)
}
